<main class="flex-1">
  <app-hero></app-hero>
  <app-categories-slider></app-categories-slider>
  <app-use-cases></app-use-cases>
  <app-call-to-action [appUrl]="appUrl"></app-call-to-action>
</main>
